import React, { useState, useLayoutEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

const ShadowDOM = ({
  as: Comp = 'div',
  children,
  ...rest
}) => {
  const [shadowRoot, setShadowRoot] = useState(null);
  const node = useRef();

  useLayoutEffect(() => {
    setShadowRoot(node.current.attachShadow({ mode: 'open' }));
  }, []);

  return (
    <Comp ref={node} {...rest}>
      {shadowRoot && createPortal(children, shadowRoot)}
    </Comp>
  );
};

export default ShadowDOM;
